import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';
import { spacing } from 'src/constants/spacing.css';

import { Text } from '../../../components';
import { Style } from '../../../constants';
import { STATE_VISUALS, bannerCopy, stateFromStatus } from '../status';

type Props = {
  aggregateState: string;
  resourceCount: number;
  affectedCount: number;
};

export default function OverallStatusBanner({
  aggregateState,
  resourceCount,
  affectedCount,
}: Props) {
  const state = stateFromStatus(aggregateState);
  const visual = STATE_VISUALS[state];
  const Icon = visual.icon;
  const { headline, subline } = bannerCopy(state, resourceCount, affectedCount);

  return (
    <html.div style={[Style.row, Style.alignCenter, styles.card]}>
      <html.span
        style={[
          styles.iconCircle,
          styles.iconCircleBackground(visual.background),
        ]}
        aria-hidden
      >
        <Icon size="1em" color={visual.foreground} />
      </html.span>
      <html.div style={[Style.col, styles.textBlock]}>
        <Text typeface="headline" color="neutral100">
          {headline}
        </Text>
        <Text typeface="body.regular" color="neutral60">
          {subline}
        </Text>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  textBlock: {
    gap: `calc(${spacing.unit} * 0.25)`,
  },
  card: {
    gap: `calc(${spacing.unit} * 1.5)`,
    backgroundColor: color.neutral0,
    borderRadius: 12,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    padding: `calc(${spacing.unit} * 1.5)`,
    '@media (max-width: 768px)': {
      padding: spacing.unit,
    },
  },
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 40,
    height: 40,
    borderRadius: 999,
    fontSize: 32,
    '@media (max-width: 768px)': {
      width: 32,
      height: 32,
      fontSize: 24,
    },
  },
  iconCircleBackground: (value: string) => ({
    backgroundColor: value,
  }),
});
